export default {
  home: 'Home',
  settings: 'Instellingen',
  logoAlt: 'logo',
  groups: {
    prod: 'Productie & Voorraad',
    excise: 'Accijns & Naleving',
    sales: 'Verkoop & Financiën',
    tools: 'Tools & Beheer',
    wiki: 'Wiki',
  },
  menu: {
    inventory: 'Inventaris',
    agp: 'AGP',
    recipes: 'Recepten',
    batches: 'Batches',
    'shopping-list': 'Boodschappenlijst',
    stock: 'Voorraad',
    planning: 'Planning',
    tools: 'Tools',
    invoices: 'Facturen',
    audit: 'Audit',
    suggestions: 'Suggesties',
    wiki: 'Wiki',
  },
};
